module.exports = __webpack_public_path__ + "static/media/Maven_5731.d723138c.jpg";